import React,{useState}from"react";
import{Box,Collapse,List,ListItemButton,Typography}from"@mui/material";
import HomeOutlinedIcon from"@mui/icons-material/HomeOutlined";
import SettingsOutlinedIcon from"@mui/icons-material/SettingsOutlined";
import DescriptionOutlinedIcon from"@mui/icons-material/DescriptionOutlined";
import EngineeringOutlinedIcon from"@mui/icons-material/EngineeringOutlined";
import ExpandLess from"@mui/icons-material/ExpandLess";
import ExpandMore from"@mui/icons-material/ExpandMore";
import{useLocation,useNavigate}from"react-router-dom";
import{useAuth}from"../../../context/AuthContext";

export default function Sidebar({open}){
  const navigate=useNavigate();
  const location=useLocation();
  const{user}=useAuth();

  const[documentsOpen,setDocumentsOpen]=useState(location.pathname.startsWith("/admin-panel/orders"));
  const[configOpen,setConfigOpen]=useState(location.pathname.startsWith("/admin-panel/configuration"));

  const role=user?.role;
  const isAdmin=role==="ADMIN";
  const isSuperAdmin=role==="SUPERADMIN";
  const isTechnician=role==="TECHNICIAN";
  const canConfigure=isSuperAdmin||isAdmin;
  const canViewDocuments=isAdmin||isTechnician;

  const itemSx=active=>({
    minHeight:open?44:58,
    mb:.5,
    borderRadius:2,
    px:open?1.5:0,
    display:"flex",
    flexDirection:open?"row":"column",
    alignItems:"center",
    justifyContent:open?"flex-start":"center",
    gap:open?1.2:.4,
    color:"#fff",
    bgcolor:active?"rgba(255,255,255,.14)":"transparent",
    "&:hover":{bgcolor:"rgba(255,255,255,.10)"},
    "& .MuiSvgIcon-root":{fontSize:open?20:19,flexShrink:0},
  });

  const labelSx={
    fontSize:open?13.5:8.5,
    fontWeight:600,
    lineHeight:1,
    whiteSpace:"nowrap",
    textAlign:open?"left":"center",
  };

  const submenuSx=active=>({
    minHeight:38,
    pl:5,
    pr:1.5,
    mb:.3,
    borderRadius:2,
    color:"#fff",
    justifyContent:"flex-start",
    textAlign:"left",
    bgcolor:active?"rgba(255,255,255,.14)":"transparent",
    "&:hover":{bgcolor:"rgba(255,255,255,.10)"},
  });

  const submenuLabelSx={
    fontSize:13,
    fontWeight:600,
    whiteSpace:"nowrap",
    textAlign:"left",
    width:"100%",
  };

  const handleDocumentsClick=()=>{
    if(open){
      setDocumentsOpen(prev=>!prev);
      return;
    }

    if(isTechnician){
      navigate("/admin-panel/orders/new");
      return;
    }

    navigate("/admin-panel/orders");
  };

  const handleConfigurationClick=()=>{
    if(open){
      setConfigOpen(prev=>!prev);
      return;
    }

    navigate("/admin-panel/configuration/smtp");
  };

  return(
    <Box sx={{width:open?230:68,minHeight:"100vh",bgcolor:"#123f6d",color:"#fff",transition:"width .2s ease",overflow:"hidden",flexShrink:0}}>
      <Box sx={{height:62,borderBottom:"1px solid rgba(255,255,255,.12)"}}/>

      <List sx={{px:open?1:.5,py:1.5}}>
        <ListItemButton onClick={()=>navigate("/admin-panel")} sx={itemSx(location.pathname==="/admin-panel")}>
          <HomeOutlinedIcon/>
          <Typography sx={labelSx}>Inicio</Typography>
        </ListItemButton>

        {isAdmin&&(
          <ListItemButton onClick={()=>navigate("/admin-panel/technicians")} sx={itemSx(location.pathname.startsWith("/admin-panel/technicians"))}>
            <EngineeringOutlinedIcon/>
            <Typography sx={labelSx}>Técnicos</Typography>
          </ListItemButton>
        )}

        {canViewDocuments&&(
          <>
            <ListItemButton onClick={handleDocumentsClick} sx={itemSx(location.pathname.startsWith("/admin-panel/orders"))}>
              <DescriptionOutlinedIcon/>
              <Typography sx={{...labelSx,flex:open?1:"initial"}}>Documentos</Typography>
              {open&&(documentsOpen?<ExpandLess sx={{fontSize:"17px !important"}}/>:<ExpandMore sx={{fontSize:"17px !important"}}/>)}
            </ListItemButton>

            {open&&(
              <Collapse in={documentsOpen} timeout="auto" unmountOnExit>
                <List disablePadding>
                  <ListItemButton
                    onClick={()=>navigate("/admin-panel/orders/new")}
                    sx={submenuSx(location.pathname==="/admin-panel/orders/new")}
                  >
                    <Typography sx={submenuLabelSx}>Nueva Orden</Typography>
                  </ListItemButton>

                  {isAdmin&&(
                    <ListItemButton
                      onClick={()=>navigate("/admin-panel/orders")}
                      sx={submenuSx(location.pathname==="/admin-panel/orders")}
                    >
                      <Typography sx={submenuLabelSx}>Órdenes de Trabajo</Typography>
                    </ListItemButton>
                  )}
                </List>
              </Collapse>
            )}
          </>
        )}

        {canConfigure&&(
          <>
            <ListItemButton onClick={handleConfigurationClick} sx={itemSx(location.pathname.startsWith("/admin-panel/configuration"))}>
              <SettingsOutlinedIcon/>
              <Typography sx={{...labelSx,flex:open?1:"initial"}}>Configuración</Typography>
              {open&&(configOpen?<ExpandLess sx={{fontSize:"17px !important"}}/>:<ExpandMore sx={{fontSize:"17px !important"}}/>)}
            </ListItemButton>

            {open&&(
              <Collapse in={configOpen} timeout="auto" unmountOnExit>
                <List disablePadding>
                  {isAdmin&&(
                    <ListItemButton
                      onClick={()=>navigate("/admin-panel/configuration/profile")}
                      sx={submenuSx(location.pathname==="/admin-panel/configuration/profile")}
                    >
                      <Typography sx={submenuLabelSx}>Mi Perfil</Typography>
                    </ListItemButton>
                  )}

                  <ListItemButton
                    onClick={()=>navigate("/admin-panel/configuration/smtp")}
                    sx={submenuSx(location.pathname==="/admin-panel/configuration/smtp")}
                  >
                    <Typography sx={submenuLabelSx}>Correo SMTP</Typography>
                  </ListItemButton>

                  {isAdmin&&(
                    <ListItemButton
                      onClick={()=>navigate("/admin-panel/configuration/notifications")}
                      sx={submenuSx(location.pathname==="/admin-panel/configuration/notifications")}
                    >
                      <Typography sx={submenuLabelSx}>Notificaciones</Typography>
                    </ListItemButton>
                  )}
                </List>
              </Collapse>
            )}
          </>
        )}
      </List>
    </Box>
  );
}